import { CheckCircleOutline, CloseOutlined } from "@mui/icons-material";

export const sortingModes = {
  CLIENT: "client",
  SERVER: "server",
};

export const sexyBooleanColumn = ({ value }) => {
  if (value == null || value == undefined) {
    return "";
  }
  return value ? (
    <CheckCircleOutline color="success" />
  ) : (
    <CloseOutlined color="error" />
  );
};

export const sexyBooleanColumnTrueOnly = ({ value }) => {
  return value ? <CheckCircleOutline color="success" /> : "";
};
export const sexyBooleanColumnFalseOnly = ({ value }) => {
  return value == false ? <CloseOutlined color="error" /> : "";
};
